import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem} from "mdbreact";
import {Link} from "react-router-dom";

const pageTitle = "راهنمای سایت";

export default class Sitemap extends Component {
    render() {
        return (
            <div >
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">{pageTitle}</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <div className="row">
                        <div className="col-sm-12" style={{minHeight:500}}>
                            <h3>{pageTitle}</h3>
                            <p>
                                <ul className="list-group sitemap mt-4 mb-3">
                                    <li className="list-group-item"><Link to='/'>صفحه نخست</Link></li>
                                    <li className="list-group-item"><Link to='/products'>محصولات</Link></li>
                                    <li className="list-group-item"><Link to='/how-it-works'>راهنمای استفاده</Link></li>
                                    <li className="list-group-item"><Link to='/community'>باشگاه مشتریان</Link></li>
                                    <li className="list-group-item"><Link to='/contact-us'>تماس با ما</Link></li>
                                    <li className="list-group-item"><Link to='/about'>درباره ما</Link></li>
                                    <li className="list-group-item">
                                        <Link to='/merchantList'> مراکز طرف قرارداد</Link>
                                        <ul className="list-group">
                                            {/*<li className="list-group-item"> <li className="list-group-item"><Link to='/merchantList'>لیست مراکز طرف قرارداد</Link></li></li>*/}
                                            <li className="list-group-item"> <li className="list-group-item"><Link to='/merchants/1'>رستوران ها و کافه ها</Link></li></li>
                                            <li className="list-group-item"> <li className="list-group-item"><Link to='/merchants/2'>هتل و گردشگری</Link></li></li>
                                            <li className="list-group-item"> <li className="list-group-item"><Link to='/merchants/3'>بلیط طلایی</Link></li></li>
                                            <li className="list-group-item"> <li className="list-group-item"><Link to='/merchants/4'>خرید و خدمات</Link></li></li>
                                        </ul>
                                    </li>





                                    <li className="list-group-item"><Link to='/shopping-card'>سبد خرید</Link></li>
                                    <li className="list-group-item"><Link to='/login'>ورود کاربران</Link></li>

                                    <li className="list-group-item"><Link to='/hotel-rules'>قوانین استفاده</Link></li>
                                    <li className="list-group-item"><Link to='/hotel-rules'>قوانین استفاده</Link></li>
                                    <li className="list-group-item"><Link to='/community'>باشگاه مشتریان </Link></li>
                                    <li className="list-group-item"><Link to='/how-it-works'>پایگاه دانش</Link></li>
                                    <li className="list-group-item"><Link to='/business'>کسب و کار</Link></li>
                                    <li className="list-group-item"><Link to='/merchant-partners'>همکاران تجار</Link></li>
                                    <li className="list-group-item"><Link to='/careers'>فرصت های شغلی</Link></li>
                                    <li className="list-group-item"><Link to='/licences'>مجوزها</Link></li>
                                    <li className="list-group-item"><Link to='/terms-of-sale'>شرایط فروش</Link></li>
                                    <li className="list-group-item"><Link to='/terms-of-use'>شرایط استفاده</Link></li>
                                    <li className="list-group-item"><Link to='/privacy-policy'>حریم خصوصی</Link></li>
                                    <li className="list-group-item"><Link to='/how-it-works' >سوالات متداول</Link></li>
                                    <li className="list-group-item active"><Link to='/sitemap' >راهنمای سایت</Link></li>


                                </ul>
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Sitemap.js